import {useState} from 'react';
import {isValidEmail, validatePassword, MAX_EMAIL_LENGTH, MAX_PASSWORD_LENGTH} from '../validation';

export default function RegisterScreen() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirm, setConfirm] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    async function handleSubmit(e) {
        e.preventDefault();
        setError('');
        if (!isValidEmail(email)) {
            setError('Please enter a valid email address.');
            return;
        }
        const pwError = validatePassword(password);
        if (pwError) {
            setError(pwError);
            return;
        }
        if (password !== confirm) {
            setError('Passwords do not match');
            return;
        }
        setSubmitting(true);
        try {
            const res = await fetch('/api/v1/auth/register', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({email, password}),
            });
            if (res.status === 403) {
                setError('Registration is not allowed for this email');
                return;
            }
            if (res.status === 409) {
                setError('An account with this email already exists');
                return;
            }
            if (!res.ok) {
                setError('Registration failed. Please try again.');
                return;
            }
            setSuccess(true);
        } catch {
            setError('Registration failed. Please try again.');
        } finally {
            setSubmitting(false);
        }
    }

    if (success) {
        return (
            <div className="login-screen">
                <div className="modal">
                    <h3 className="modal-title">Check your inbox</h3>
                    <p className="modal-warning">
                        Verification email sent to <strong>{email}</strong>. Click the link to activate your account.
                    </p>
                    <p className="login-register-link">
                        <a href="/?signin">Back to sign in</a>
                    </p>
                </div>
            </div>
        );
    }

    return (
        <div className="login-screen">
            <form className="register-form login-form" onSubmit={handleSubmit} noValidate>
                <h2 className="login-title">Create account</h2>
                {error ? <p className="login-error">{error}</p> : null}
                <input
                    className="login-input"
                    type="email"
                    placeholder="Email"
                    value={email}
                    maxLength={MAX_EMAIL_LENGTH}
                    onChange={e => setEmail(e.target.value)}
                    autoFocus
                />
                <input
                    className="login-input"
                    type="password"
                    placeholder="Password"
                    value={password}
                    maxLength={MAX_PASSWORD_LENGTH}
                    onChange={e => setPassword(e.target.value)}
                />
                <input
                    className="login-input"
                    type="password"
                    placeholder="Confirm password"
                    value={confirm}
                    maxLength={MAX_PASSWORD_LENGTH}
                    onChange={e => setConfirm(e.target.value)}
                />
                <button
                    className="login-button"
                    type="submit"
                    disabled={!email || !password || !confirm || submitting}
                >{submitting ? 'Creating account...' : 'Create account'}</button>
                <p className="login-register-link">
                    Already have an account? <a href="/?signin">Sign in</a>
                </p>
            </form>
        </div>
    );
}
